import { useState } from "react";
import { Button, Col, Container, Image, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useToasts } from "react-toast-notifications";
import logo from '../../../assets/logo_stride.png';
import { AuthActionEnum, ErrorMessageEnum, SuccessMessageEnum } from "../../../enums/app.enum";
import { authService } from '../../../services/auth.service';
import { utils } from '../../../_helpers';
import SInputComponent from '../../s-input/s-input.component';
import CloseIcon from "../close-icon/close-icon.component";

/**
 * Modal delect
 * @param {*} props Modal props
 * @param {*} props.onHide callback function when close modal
 * @returns
 */
const ForgotPasswordModal = (props: any) => {
  const { clearErrors, control, handleSubmit, setError, formState: { errors } } = useForm();
  const { addToast } = useToasts();

  const onSubmit = (formData: any) => {
    // let isError = false;

    // if (!formData.email) {
    //   setError('email', { type: 'required', message: ErrorMessageEnum.requiredFieldMessage })
    //   isError = true
    // }

    // if (!utils.validEmail(formData.email)) {
    //   setError('email', { type: 'manual', message: ErrorMessageEnum.invalidEmail })
    //   isError = true
    // }

    // if (isError) return false;

    authService.requestResetPassword(formData).then(res => {
      addToast(SuccessMessageEnum.resetPasswordLinkSent, { appearance: 'success' })
    }).catch(err => {
      clearErrors()
      setError('email', { type: 'manual', message: err.response.data?.message })
      // if (err.data.errors && err.data.errors.length > 0) {
      //   err.data.errors.forEach((errorDetail: any) => {
      //     if (errorDetail.key) {
      //       setError(errorDetail.key, { type: 'manual', message: errorDetail.message })
      //     }
      //   });
      // } else {
      //   addToast(err.data.message, { appearance: 'error' })
      // }
    })
  }

  const handleOpenLogin = () => {
    props.onHide(AuthActionEnum.OPEN_LOGIN)
  }

  return (
    <Modal {...props} animation={false} centered>
      <Modal.Body className="text-center">
        <CloseIcon onClicked={props.onHide} />
        <Container>
          <Row>
            <Col>
              <Image src={logo} width="300" className="my-4" />
              <div>
                <p className='text-14'>Enter your registered email address and we will send the recovery password link to your registered email</p>
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="d-flex flex-column justify-content-center px-sm-6 mt-5">
                  <SInputComponent name="email" type='text' placeholder="Email" control={control} error={errors.email} className='mt-3'
                    rules={{
                      required: { value: true, message: ErrorMessageEnum.requiredFieldMessage },
                      validate: (val: string) => {
                        return utils.validEmail(val) || ErrorMessageEnum.invalidEmail
                      }
                    }}
                  />
                  {/* <div className='mt-1'><span className='text-primary pointer text-14 fw-7 letter-86' onClick={handleSubmit(onSubmit)}>Resent Link</span></div> */}
                </div>
                <div className="px-sm-6 mt-6">
                  <Button type='submit' variant='danger' block className="mt-2 py-2 btn-signup">SEND CODE</Button>
                  <div className='mt-4'><span className='text-primary pointer text-14 fw-7 letter-86' onClick={handleOpenLogin}>Back to login</span></div>
                </div>
              </form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal >
  );
}

export default ForgotPasswordModal;
